<template>
  <div class="window" v-if="!windowHidden">
    <div class="window__title" v-if="$slots.title">
      <slot name="title"/>
      <Icon class="window__close-btn" @click="close">
        <XIcon />
      </Icon>
    </div>
    <div class="window__body">
      <slot />
    </div>
  </div>
</template>
<script>
  import { XIcon } from '@zhuowenli/vue-feather-icons';
  import Icon from "./icon.vue";

  export default {
    name: "Window",
    data() {
      return { windowHidden: !!this.hidden }
    },
    components: { Icon, XIcon },
    props: {
      hidden: Boolean,
      onShow: Function,
      onClose: Function,
    },
    methods: {
      show() {
        this.windowHidden = false;
      },
      close() {
        this.windowHidden = true;
        this.onClose && this.onClose();
      }
    }
  }
</script>
